export const NOTIFICATIONS_CONSENT_DOCUMENT_VERSION = '2026-08-15'

export const NOTIFICATIONS_CONSENT_PATH = '/legal/notifications-consent'

export const NOTIFICATIONS_CONSENT_CHECKBOX_LABEL =
  'Согласен на получение информационных сообщений о заявках и их статусах по электронной почте и в мессенджерах'
